import React from 'react'
import { withTranslation } from 'react-i18next'

import ErrorLabel from 'app/components/ErrorLabel/ErrorLabel'

const ProfileFormFirstNameInput = ({ t, input, meta: { error, touched } }) => (
  <div className="profile-input">
    <div className="profile-input__label-wrapper">
      <label htmlFor="profile-input-first-name" className="profile-input__label">
        {t('First Name')}
      </label>
    </div>
    <input
      type="text"
      placeholder="John"
      id="profile-input-first-name"
      {...input}
      className={`profile-input__field ${touched && error ? 'error' : ''}`}
    />
    {touched && error && <ErrorLabel before="First Name" htmlFor="profile-input-first-name" error={error} />}
  </div>
)

ProfileFormFirstNameInput.displayName = 'ProfileFormFirstNameInput'

export default withTranslation('user')(ProfileFormFirstNameInput)
